import { render, staticRenderFns } from "./UserAvatarSmall.vue?vue&type=template&id=33a59011"
import script from "./UserAvatarSmall.vue?vue&type=script&lang=js"
export * from "./UserAvatarSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33a59011')) {
      api.createRecord('33a59011', component.options)
    } else {
      api.reload('33a59011', component.options)
    }
    module.hot.accept("./UserAvatarSmall.vue?vue&type=template&id=33a59011", function () {
      api.rerender('33a59011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/UserAvatarSmall.vue"
export default component.exports